import {svg2imageData} from '@/api/Utilities.js'

// v9 moduler 方式
import { firebaseApp } from '@/firebase.js'
import { getStorage, ref, uploadString, getDownloadURL, uploadBytes } from 'firebase/storage'
import { getMyUserId } from '@/api/FirebaseUserWrapper.js'

const storage = getStorage(firebaseApp)

/*
 * Storage関連
 */

/**
  * putOGPImageInStorage:
  *   OGP用のSVGをPNGに変換してStoregeにUploadする
  * @param {object} canvas キャンバス画像
  * @param {string} treeId 対象のtreeId
  * @returns {boolean}
  */
export async function putOGPImageInStorage (canvas, treeId) {
  const data = await svg2imageData(canvas)
  const filePath = '/trees/' + treeId
  const storageRef = ref(storage, filePath)
  try {
    await uploadString(storageRef, data, 'data_url')
  } catch (err) {
    console.log(err)
  }
}
/**
 * getStorageURLForOGP:
 *  対象のTreeのOGP用のURLを返却する
 * @param {string} treeId 対象のtreeId
 * @returns {string|null}
 */
export async function getStorageURLForOGP (treeId) {
  const filePath = '/trees/' + treeId
  const storageRef = ref(storage, filePath)
  try {
    const url = await getDownloadURL(storageRef)
    return url
  } catch (err) {
    return null
  }
}

/**
  * putProfileImageInStorage:
  *   Profile ImageをStorageにuploadしてurlを返却
  * @param {object} 画像ファイル
  * @returns {string|null} 画像urlを返却
  */
export async function putProfileImageInStorage (file) {
  const userId = await getMyUserId()
  const filePath = 'users/' + userId + '/profile'
  const storageRef = ref(storage, filePath)
  try {
    await uploadBytes(storageRef, file)
    const url = await getDownloadURL(storageRef)
    return url
  } catch (err) {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/api/FirebaseStorageWrapper.js